import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Radio } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const WebhookNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data.label || 'Webhook'}
            icon={Radio}
            colorClass="text-yellow-600"
            bgClass="bg-yellow-100"
            selected={selected}
            isTarget={false}  // Triggers have no input handle
            isSource={true}
            executionStatus={data?.executionStatus}
        />
    );
};

export default memo(WebhookNode);
